import React from 'react';
import type { TutorialStepT } from '../../../common/types/types';
import { CUBOID_TUTORIAL_CONFIG } from './cuboid-tutorial';
import { POLYGON_TUTORIAL_CONFIG } from './polygon-tutorial';
import { POLYLINE_TUTORIAL_CONFIG } from './polyline-tutorial';
export const TOOLBAR_TUTORIAL_ID = ({
  polygon: 'select-tool-POLYGON',
  polyline: 'select-tool-POLYLINE',
  cuboid: 'select-tool-CUBOID'
} as const);
export const TOOLBAR_TUTORIAL: {
  [key: string]: Omit<TutorialStepT, 'getTarget'> | undefined;
} = {
  [TOOLBAR_TUTORIAL_ID.polygon]: {
    version: 1,
    id: 'select-polygon',
    render: () => <div>Select the polygon tool to draw polygon.</div>,
    disableNext: true,
    isRoot: true,
    nextId: POLYGON_TUTORIAL_CONFIG.drawPolygon.id
  },
  [TOOLBAR_TUTORIAL_ID.polyline]: {
    version: 1,
    id: 'select-polyline',
    render: () => <div>Select the polyline tool to draw polyline.</div>,
    disableNext: true,
    isRoot: true,
    nextId: POLYLINE_TUTORIAL_CONFIG.drawPolyline.id
  },
  [TOOLBAR_TUTORIAL_ID.cuboid]: {
    version: 1,
    id: 'select-cuboid',
    render: () => <div>Select cuboid drawing tool to draw cuboid.</div>,
    disableNext: true,
    isRoot: true,
    nextId: CUBOID_TUTORIAL_CONFIG.drawCuboid.id
  }
};
export const TUTORIAL_LIST_DISPLAY_NAME = {
  POLYGON: 'Polygon',
  POLYLINE: 'Polyline',
  CUBOID: 'Cuboid'
};